import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { MSpinner } from "components/Shared";
import {
  ContactInformation,
  SpecialAttentionNotes,
  Address,
} from "components/QualityAssurance";
import OrderInformation from "components/Homeowner/CaseDetails/OrderInformation";
import { FontIcon, Cell } from "react-md";
import { NOT_PROVIDED } from "typeConstants/stringConstants";
import { GetDisplayFieldValue } from "components/Shared/Formatters";
import { getCaseType } from "components/Shared/Functions";
import AppointmentInformation from "components/Homeowner/CaseForms/AppointmentInformation";
import CaseStepper from "components/Homeowner/CaseStepper";
import { STATUS_TRACKER } from "components/Homeowner/CaseStepper/StepTypes";
import AppraiserAssignmentApproval from "components/Homeowner/CaseForms/AppraiserAssignmentApproval";
import { userHasRight } from "selectors/rights";

import {
  APPRAISAL_ASSIGNMENT_APPROVAL_VIEW, 
  APPRAISAL_ASSIGNMENT_APPROVAL_EDIT  } from "typeConstants/rights";

// Actions
import {
  getCaseHeader,
  updateCaseHeader
} from "actions/homeowner/caseforms";

function CaseHeaderTitle({ count }) {
  const issuesIconType = count === 0 ? "thumb_up" : "thumb_down";
  const description =
    count === 1
      ? "There is 1 unresolved QA Issue"
      : "There are " + (count === 0 ? "no" : count) + " unresolved QA Issues";

  return (
    <div>
      <FontIcon secondary inherit style={{ marginRight: "0.5em" }}>
        {issuesIconType}
      </FontIcon>
      {description}
    </div>
  );
}
CaseHeaderTitle.propTypes = { count: PropTypes.number };

class BrokerCaseHeader extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.appraiserContactInfo;
    this.brokerContactInfo;
    this.expanderClicked = this.expanderClicked.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.getCellSize = this.getCellSize.bind(this);
    this.state = {
      qaExpended: false,
      visibleDialog: false,
      enabledTooltip: ""
    };
  }

  componentDidUpdate(prevProps) {
    if ((this.props.updatingCaseHeader === false && prevProps.updatingCaseHeader) || //just finished an update
      (this.props.controlNumber != prevProps.controlNumber)) {
      this.props.getCaseHeader(this.props.controlNumber);
    }
  }

  expanderClicked(val) { this.setState({ qaExpanded: val }); }
  getCellSize(requestedSize) { return this.props.verticalDisplay ? 12 : requestedSize; }
  hide() { this.setState({ visibleDialog: false }); }
  show() { this.setState({ visibleDialog: true }); }

  render() {
    const {
      controlNumber, fetchingHeader, caseHeader,
      getCaseHeader, updateCaseHeader, updatingCaseHeader,
      caseStepper
    } = this.props;
    const { caseInfo, policyInfo } = caseHeader;
    if (fetchingHeader || !policyInfo) { return <MSpinner />; }
    const { surveyAddress, mailingAddress, customerInfo, caseAttributes } = policyInfo;
    const { customerName, customerType } = customerInfo;

    let webNotes = caseInfo.webNotes;
    if (webNotes != null && webNotes.length > 0) {
      webNotes = webNotes.replace(/(?:\r\n|\r|\n)/g, "<br />");
    } else {
      webNotes = NOT_PROVIDED;
    }

    let surveyRemarks = policyInfo.surveyRemarks;
    if (surveyRemarks != null && surveyRemarks.length > 0) {
      surveyRemarks = surveyRemarks.replace(/(?:\r\n|\r|\n)/g, "<br />");
    } else {
      surveyRemarks = NOT_PROVIDED;
    }

    let caseType = getCaseType(customerType);

    const reportType = GetDisplayFieldValue(caseHeader.displayFields, "ReportType");

    return (
      <div id={caseHeader.wrappableId} className="case-header md-grid md-grid-cards no-padding">
        <Cell size={this.getCellSize(12)} tabletSize={12} phoneSize={12} className={!caseStepper.trackerActive ? "case-stepper-disabled" : ""}>
          <CaseStepper
            controlNumber={controlNumber}
            stepType={STATUS_TRACKER}
            navigateToCase={this.props.navigateToCase}
            openCaseTab={this.props.openCaseTab}
          />
        </Cell>
        <Cell size={this.getCellSize(6)} tabletSize={12} phoneSize={12}>
          <OrderInformation
            controlNumber={controlNumber}
            {...{ reportType }}
            policyOrLoanNumber={GetDisplayFieldValue(caseHeader.displayFields, "PolicyNumber")}
            trackingNumber={GetDisplayFieldValue(caseHeader.displayFields, "TrackingNumber")}
            assignmentType={caseAttributes.transactionType}
            customerName={customerName}
            customerNumber={customerInfo.customerNumber}
            orderedDate={GetDisplayFieldValue(caseHeader.displayFields, "DateOrdered")}
            completedDate={GetDisplayFieldValue(caseHeader.displayFields, "DateCompleted")}
            caseType={caseType}
            AppraisalStatus={GetDisplayFieldValue(caseHeader.displayFields, "AppraisalStatus")}
            customerDueDate={GetDisplayFieldValue(caseHeader.displayFields, "CustomerDueDate")}
            showAsTwoColumn={!this.props.verticalDisplay}
            legacyDataEntryPageLink={caseHeader.legacyDataEntryPageLink}
            surveyDate={GetDisplayFieldValue(caseHeader.displayFields, "DateSurveyed")}
            channel={caseAttributes.channel}
          />
        </Cell>
        <Cell size={this.getCellSize(6)} tabletSize={12} phoneSize={12}>
          <ContactInformation
            controlNumber={controlNumber}
            {...{ reportType }}
            borrower={{
              name: policyInfo.policyHolderInfo.policyholderName.fullName,
              firstName: policyInfo.policyHolderInfo.policyholderName.firstName,
              lastName: policyInfo.policyHolderInfo.policyholderName.lastName,
              homePhone: policyInfo.policyHolderInfo.policyholderPhoneHome,
              workPhone: policyInfo.policyHolderInfo.policyholderPhoneWork,
              email: policyInfo.policyHolderInfo.policyholderEmail,
              designatedContactName: policyInfo.policyHolderInfo.designatedContactName,
              designatedContactPhone1: policyInfo.policyHolderInfo.designatedContactPhone1,
              designatedContactPhone2: policyInfo.policyHolderInfo.designatedContactPhone2,
              designatedContactEmail: policyInfo.policyHolderInfo.designatedContactEmail,
            }}
            fieldRep={{
              name: caseInfo.inspectorNumber,
            }}
            appraiser={{
              name: caseInfo.appraiserNumber,
            }}
            broker={caseInfo.broker && { name: caseInfo.broker.fullName, email: caseInfo.broker.email, phoneNumber: caseInfo.broker.phoneNumber }}
            caseType={caseType}
            isEditable={false}
            updateCaseHeader={null}
            FRList={[]}
            caseStatus={null}
            getCaseHeader={getCaseHeader}
            canChangeAppraiserAssignment={false}
          />
        </Cell>
        <Cell size={this.getCellSize(4)} tabletSize={12} phoneSize={12}>
          <Address
            controlNumber={controlNumber}
            mailingProps={{
              address: GetDisplayFieldValue(caseHeader.displayFields, "MailingAddress"),
              county: GetDisplayFieldValue(caseHeader.displayFields, "MailingCounty"),
              rawAddress: mailingAddress,
            }}
            subjectProps={{
              address: GetDisplayFieldValue(caseHeader.displayFields, "SurveyAddress"),
              county: GetDisplayFieldValue(caseHeader.displayFields, "County"),
              state: GetDisplayFieldValue(caseHeader.displayFields, "SurveyState"),
              geocode: GetDisplayFieldValue(caseHeader.displayFields, "GeoCode"),
              rawAddress: surveyAddress,
            }}
            update={updateCaseHeader}
            isUpdating={updatingCaseHeader}
            isEditable={caseHeader.canUserEdit}
            getData={getCaseHeader}
          />
        </Cell>
        <Cell size={this.getCellSize(4)} tabletSize={12} phoneSize={12}>
          <AppointmentInformation
            appointmentDateTime={caseInfo.appointmentDateTime}
            appointmentRequired={caseInfo.appointmentRequired}
            appointmentNotes={caseInfo.appointmentNotes}
            caseType={caseType}
            controlNumber={controlNumber}
          />
        </Cell>
        {this.props.showAppraiserApprovalCard && this.state.hasAssignmentApproval &&
          <Cell size={this.getCellSize(6)} tabletSize={12} phoneSize={12}>
            <AppraiserAssignmentApproval controlNumber={controlNumber} setHasData={(resp) => this.setState({hasAppraisalSurveyInfo: resp})} />      
          </Cell>        
        }
        <Cell size={this.getCellSize(4)} tabletSize={12} phoneSize={12}>
          <SpecialAttentionNotes text={webNotes} />
        </Cell>
      </div>
    );
  }
}

BrokerCaseHeader.propTypes = {
  controlNumber: PropTypes.number,

  verticalDisplay: PropTypes.bool,
  showHistory: PropTypes.bool,
  roles: PropTypes.array,
  rights: PropTypes.array,

  // locally connected
  caseHeader: PropTypes.object.isRequired,
  fetchingHeader: PropTypes.bool.isRequired,
  updatingCaseHeader: PropTypes.bool,
  updateCaseHeader: PropTypes.func,
  getCaseHeader: PropTypes.func,

  FRList: PropTypes.array,
  isFetchingFRList: PropTypes.bool,

  caseStepper: PropTypes.object,
  navigateToCase: PropTypes.func,
  openCaseTab: PropTypes.func,

  showAppraiserApprovalCard: PropTypes.bool, 
};

// Connect
const mapStateToProps = state => {
  return {
    caseHeader: state.caseForms.caseHeader,
    fetchingHeader: state.caseForms.fetchingHeader,
    updatingCaseHeader: state.caseForms.updatingCaseHeader,

    FRList: state.fieldRep.fieldRepsBasic,
    isFetchingFRList: state.fieldRep.isFetchingFieldReps,
    roles: state.user.profile.roles,

    caseStepper: state.caseStepper,

    showAppraiserApprovalCard: userHasRight(APPRAISAL_ASSIGNMENT_APPROVAL_EDIT)(state) || userHasRight(APPRAISAL_ASSIGNMENT_APPROVAL_VIEW)(state),   
  };
};
const mapDispatchToProps = dispatch => ({
  getCaseHeader(controlNumber) {
    dispatch(getCaseHeader(controlNumber));
  },
  updateCaseHeader(controlNumber, dto, callback = null) {
    dispatch(updateCaseHeader(controlNumber, dto, callback));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps)(BrokerCaseHeader);
